/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { IWiseTableAdvancedFilter } from 'components/wise/types';

interface IComponentParameters {
  page?: number;
  limit?: number;
  [key: string]: any;
}

interface ITraderPanelParameters {
  [componentSymbol: string]: IComponentParameters;
}

interface ITraderPanelSlice {
  parameters: ITraderPanelParameters;
  wiseTableAdvancedFilters: {
    [componentSymbol: string]: IWiseTableAdvancedFilter[];
  };
  wiseTableColumnVisibility: {
    [componentSymbol: string]: Record<string, boolean>;
  };
  wiseTableColumnOrder: {
    [componentSymbol: string]: string[];
  };
  wiseTableSelectedSettingsPresetId: {
    [componentSymbol: string]: string | null;
  };
}

const initialState: ITraderPanelSlice = {
  parameters: {},
  wiseTableAdvancedFilters: {},
  wiseTableColumnVisibility: {},
  wiseTableColumnOrder: {},
  wiseTableSelectedSettingsPresetId: {}
};

export const traderPanelSlice = createSlice({
  name: 'traderPanel',
  initialState,
  reducers: {
    setTraderPanelParameters: (state, action: PayloadAction<{ componentSymbol: string; parameters: IComponentParameters }>) => {
      state.parameters[action.payload.componentSymbol] = action.payload.parameters;
    },

    addTraderPanelWiseTableAdvancedFilter: (
      state,
      action: PayloadAction<{ componentSymbol: string; filter: IWiseTableAdvancedFilter }>
    ) => {
      const { componentSymbol, filter } = action.payload;
      if (!componentSymbol) return;
      if (!Array.isArray(state.wiseTableAdvancedFilters[componentSymbol])) {
        state.wiseTableAdvancedFilters[componentSymbol] = [];
      }
      state.wiseTableAdvancedFilters[componentSymbol].push(filter);
    },

    setTraderPanelWiseTableAdvancedFilters: (
      state,
      action: PayloadAction<{ componentSymbol: string; filters: IWiseTableAdvancedFilter[] }>
    ) => {
      const { componentSymbol, filters } = action.payload;
      if (!componentSymbol) return;
      state.wiseTableAdvancedFilters[componentSymbol] = filters;
    },

    setTraderPanelWiseTableColumnVisibility: (
      state,
      action: PayloadAction<{
        componentSymbol: string;
        columnVisibility: Record<string, boolean>;
      }>
    ) => {
      const { componentSymbol, columnVisibility } = action.payload;
      if (!componentSymbol) return;
      state.wiseTableColumnVisibility[componentSymbol] = columnVisibility;
    },

    setTraderPanelWiseTableColumnOrder: (
      state,
      action: PayloadAction<{
        componentSymbol: string;
        columnOrder: string[];
      }>
    ) => {
      const { componentSymbol, columnOrder } = action.payload;
      if (!componentSymbol) return;
      state.wiseTableColumnOrder[componentSymbol] = columnOrder;
    },

    setTraderPanelWiseTableSelectedSettingsPresetId: (
      state,
      action: PayloadAction<{
        componentSymbol: string;
        presetId: string | null;
      }>
    ) => {
      const { componentSymbol, presetId } = action.payload;
      if (!componentSymbol) return;
      state.wiseTableSelectedSettingsPresetId[componentSymbol] = presetId;
    }
  }
});

export const traderPanelSliceActions = traderPanelSlice.actions;
export default traderPanelSlice.reducer;
